import { Pipe, PipeTransform } from '@angular/core';
import { hasOutOfStockLines } from '@features/reserve-in-store/helper/has-out-of-stock-lines';
import { ReserveProductDetail } from '@features/reserve-in-store/reserve-in-store';

@Pipe({
    name: 'hasOutOfStockLines',
    standalone: true
})
export class HasOutOfStockLinesPipe implements PipeTransform {
    transform(lines: ReserveProductDetail[]): boolean {
        return !lines.length || hasOutOfStockLines(lines);
    }
}
